import PRODUCT_TYPE from "../const/products";
var isInstallmentLoanMonthlyType = function (type) {
    return type === PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY;
};
export default isInstallmentLoanMonthlyType;
//# sourceMappingURL=isInstallmentLoanMonthlyType.js.map